import React from 'react';

const Testimonials = ({testimonials}) => (
  <section className="bg-indigo-100 mt-20">
    <div className="max-w-7xl mx-auto md:grid md:grid-cols-2 md:px-6 lg:px-8">
      {testimonials.map((t) => (
        <div className="py-8 px-4 sm:px-6 md:flex md:flex-col md:py-16 md:pl-0 md:pr-10 lg:pr-16">
          <blockquote className="border-0 md:flex-grow md:flex md:flex-col">
            <div className="relative text-lg font-medium text-gray-900">
              <svg className="absolute -top-1 left-0 transform -translate-x-3 -translate-y-2 h-8 w-8 text-indigo-200" fill="currentColor" viewBox="0 0 32 32" aria-hidden="true">
                <path d="M9.352 4C4.456 7.456 1 13.12 1 19.36c0 5.088 3.072 8.064 6.624 8.064 3.36 0 5.856-2.688 5.856-5.856 0-3.168-2.208-5.472-5.088-5.472-.576 0-1.344.096-1.536.192.48-3.264 3.552-7.104 6.624-9.024L9.352 4zm16.512 0c-4.8 3.456-8.256 9.12-8.256 15.36 0 5.088 3.072 8.064 6.624 8.064 3.264 0 5.856-2.688 5.856-5.856 0-3.168-2.304-5.472-5.184-5.472-.576 0-1.248.096-1.44.192.48-3.264 3.456-7.104 6.528-9.024L25.864 4z" />
              </svg>
              <p className="relative">{t.quote || t.text}</p>
            </div>
            <div className="mt-4 flex items-start">
              <div className="flex-shrink-0 inline-flex rounded-full">
                <img className="h-14 w-14 rounded-full object-cover" src={t.image} alt={t.name} />
              </div>
              <div className="ml-4">
                <div className="text-base font-medium text-gray-900">{t.name}</div>
                <div className="text-base font-medium text-gray-500">{t.title}</div>
              </div>
            </div>
          </blockquote>
        </div>
      ))}
    </div>
  </section>
);

export default Testimonials;
